import React from 'react';
import { Button as ChakraButton } from '@chakra-ui/core';
import { pxToRem } from '../../../utils/dimensionConverter';

export const Button = ({ name, brand, icon, dataSelector="data-test", ...props }) => {
  return (
    <ChakraButton
      {...props}
      data-selector={dataSelector}
      variantColor={brand}
      rounded={pxToRem(12)}
      border='none'
      fontWeight={brand === 'tertiary' ? '500' : '700'}
      fontSize={brand === 'tertiary' ? pxToRem(13) : pxToRem(14)}
      color={buttonStyles.color.default[brand]}
      bg={buttonStyles.bg.default[brand]}
      cursor='pointer'
      _hover={{
        bg: buttonStyles.bg.hover[brand],
        color: buttonStyles.color.hover[brand]
      }}
      _disabled={{
        bg: buttonStyles.bg.disabled[brand],
        color: buttonStyles.color.disabled[brand],
        cursor: 'not-allowed'
      }}
      _active={{
        bg: buttonStyles.bg.active[brand],
        color: buttonStyles.color.active[brand]
      }}
      _focus={{
        boxShadow: 'none'
      }}
    >
      {icon}
      {name}
    </ChakraButton>
  )
}

const buttonStyles = {
  bg: {
    default: {
      default: '#EEEEEE',
      primary: '#93328E',
      secondary: '#EFE7F0',
      tertiary: 'transparent',
      custom: '#EFE7F0',
      active: '#93328E',
    },
    active: {
      default: '#EFE7F0',
      primary: '#5A1155',
      secondary: '#93328E',
      tertiary: 'transparent',
      custom: 'transparent',
      active: '#93328E'
    },
    hover: {
      default: '#EFE7F0',
      primary: '#72246c',
      secondary: '#EBDFEA',
      tertiary: 'transparent',
      custom: 'transparent',
      active: '#93328E'
    },
    disabled: {
      primary: '#736973',
      secondary: '#F3F3F3',
      tertiary: 'transparent',
      default: '#F3F3F3',
      custom: 'transparent',
    }
  },
  color: {
    default: {
      primary: 'white',
      secondary: '#93328E',
      tertiary: '#574C57',
      default: '#574C57',
      custom: '#574C57',
      active: 'white'
    },
    active: {
      primary: 'white',
      secondary: 'white',
      tertiary: '#72246C',
      default: '#72246C',
      custom: 'transparent',
      active: '#93328E'
    },
    hover: {
      primary: 'white',
      secondary: '#93328E',
      tertiary: '#93328E',
      default: '#93328E',
      custom: '#574C57'
    },
    disabled: {
      primary: 'white',
      secondary: '#B3AEB3',
      tertiary: '#C6C6C6',
      default: '#736973',
    }
  }
}

export default Button;
